/**
 * Force-remove any persisted Supabase auth tokens from localStorage.
 *
 * supabase-js's `signOut()` skips this cleanup when the server logout request
 * fails (network error / timeout / CORS / 5xx) — it returns the error but leaves
 * the `sb-<ref>-auth-token` entry in place, which `getSession()` + `autoRefreshToken`
 * then silently revive on the next page load. Call this unconditionally after
 * `signOut()` so a failed server logout can never leave a recoverable session.
 */
export function clearSupabaseAuthStorage(): void {
  try {
    const keys: string[] = []
    for (let i = 0; i < localStorage.length; i++) {
      const k = localStorage.key(i)
      // matches sb-<ref>-auth-token and its -code-verifier sibling
      if (k && k.startsWith('sb-') && (k.includes('-auth-token') || k.endsWith('-code-verifier'))) {
        keys.push(k)
      }
    }
    keys.forEach((k) => localStorage.removeItem(k))
  } catch {
    /* sandboxed contexts may block localStorage */
  }
}
